import setupNews from '@/api/website/setup-news'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState,
    edit_data: {},
    newsCategories: [],
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_EDIT_DATA(state, data) {
        state.edit_data = data
    },
    SET_NEWS_CATEGORIES(state, data) {
        state.newsCategories = data
    },
}

export const actions = {
    fetch(context, attributes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        )
        return setupNews.get({ params })
            .then(response => {
                console.log('Fetched Data:', response);
                context.commit('RECEIVE_RESOURCES', response)
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Fetch Error:', error);
                return Promise.reject(error.response.data);
            });
    },
    store(context, data) {
        return setupNews.store(data)
    },
    update(context, { id, data }) {
        return setupNews.update(id, data)
    },
    find(context, id) {
        return setupNews.find(id)
    },
    uploadFile(context, data) {
        return setupNews.uploadfile(data)
    },
    newImageContent(context, data) {
        return setupNews.newImageContent(data)
    },
    readImage(context, id) {
        return setupNews.readImage(id)
    },
    destroy(context, id) {
        return setupNews.destroy(id)
    },
    async getNewsCategory(context, attributes = {}) {
        let response = await setupNews.newsCategory({
            params: attributes
        })
        context.commit('SET_NEWS_CATEGORIES', response.data)
    },



}
